<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Welcome!</h1>
        <div class="description">
          Please log in using your email <br />
          address and password
        </div>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">
          <validation-summary :errors="errors"></validation-summary>
          <v-form-group :validator="$v.email"
                        label="Email">
            <b-form-input slot-scope="{ attrs, delayedListeners }"
                          v-bind="attrs"
                          v-on="delayedListeners"
                          v-model="email"
                          type="email"
                          placeholder="Email" />
          </v-form-group>

          <form-input-password v-model="password"
                               :validator="$v.password"
                               label="Password">
          </form-input-password>

          <b-form-group class="text-right">
            <router-link class="text-secondary" to="/auth/forgot-password">Forgot Password</router-link>
          </b-form-group>

          <div class="form-group">
            <b-button :loading="loading" size="lg" variant="success" type="submit">Log In</b-button>
          </div>
        </b-form>
      </div>
      <p>
        The information we provide at Precision Health Reports is <br />
        not intended to replace consultation with a qualified medical <br />
        professional. By interacting with this site, you agree to our <br />
        <a href="https://precisionhealthreports.com/privacy">Privacy Policy</a> and <a href="https://precisionhealthreports.com/terms">Terms of Use.</a>
      </p>
      <div class="page-form-footer">
        <div class="footer-description">
          Are you a healthcare provider or wellness <br />
          coach that is not a client yet?
        </div>
        <a class="footer-link text-success" href="mailto:hello@precisionhealthreports.com">
          Contact us for a demo today!
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, email } from "vuelidate/lib/validators";
  import formMixin from "mixins/form-mixin";
  import { tryStartSignalRConnection } from "@/services/signalr-service";

  export default {
    mixins: [formMixin],
    data() {
      return {
        email: "",
        password: "",
        rememberMe: false
      };
    },

    validations: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    },

    created() {
      if (this.$route.query?.email)
        this.email = this.$route.query.email;
    },

    methods: {
      getAfterLoginRedirect() {
        if (this.$auth.userInfo.roles.some(r => r === "Admin"))
          return "/reports";

        return this.$route.query.redirect || "/";
      },

      async onSubmit() {
        await this.$auth.login(
          this.email,
          this.password,
          this.rememberMe,
          this.getAfterLoginRedirect
        );

        tryStartSignalRConnection((reportId) => {
          this.$root.errorToast("The order has been released due to your inactivity.");

          const path = this.$route.path;

          if (path === "/reports" || path === `/reports/${reportId}/view`) {
            this.$router.push("/");
          }
        });
      },
    }
  };
</script>
<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/stethoscope.png');
  }
</style>